
import { defineComponent, onBeforeMount, ref } from 'vue';

export default defineComponent({
  name: 'CohortLanding',
  props: { data: { type: Object, default: null } },
  setup(props) {
    const initialData = ref();
    const videoUrl = ref();
    const selectTaskwithPeerReview = ref(false);
    const systemAssignTaskwithPeerReview = ref(false);
    const systemAssignTaskwithSignleReview = ref(false);
    const selectTaskwithSignleReview = ref(false);
    onBeforeMount(async () => {
      initialData.value = props.data;

      videoUrl.value = initialData.value.systemSetting.product_video_link;
    });

    return {
      initialData,
      videoUrl,
      selectTaskwithPeerReview,
      systemAssignTaskwithPeerReview,
      systemAssignTaskwithSignleReview,
      selectTaskwithSignleReview,
    };
  },
});
